export default [
    {
        path: '/ancillary',
        name: 'Ancillary',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/ancillary/AncillaryIndex.vue'),
        },
    },
];
